import { Feature } from "ol";
import Circle from "ol/geom/Circle";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import config from "../config";
import getStyleRondMaille1Variable from "../Styles/StyleRondMaille1Variable";
import getStyleRondMaille2Variables from "../Styles/StyleRondMaille2Variables";


export async function calculerMailles(state) {
    var maillage = "";
    var variable1 = state.theme1;
    var variable2 = state.theme2;
    var variable3 = state.theme3;
    var cercleproportionnel = state.cercleproportionnel;
    // Si rien n'est sélectionné, ne rien faire
    if (variable1!=null || variable2!=null  || variable3!=null || cercleproportionnel !=null) { 

        var listecolonnes = [];
        var requette = "select ST_X(ST_Transform(geom,3857)) x,ST_Y(ST_Transform(geom,3857)) y,num as id,";
        if (typeof variable1 !== 'undefined') {
            listecolonnes.push(state.theme1.colonne + " var1");
        }
        if (typeof variable2 !== 'undefined') {
            listecolonnes.push(state.theme2.colonne + " var2");
        }
        if (typeof variable3 !== 'undefined') {
            listecolonnes.push(state.theme3.colonne + " var3");
        }
        if (typeof cercleproportionnel !== 'undefined') {
            listecolonnes.push(cercleproportionnel.colonne + " var4");
        }

        switch (listecolonnes.length) {
            case 1:
                requette += listecolonnes[0];
                break;
            case 2:
                requette += listecolonnes[0] + "," + listecolonnes[1];
                break;
            case 3:
                requette += listecolonnes[0] + "," + listecolonnes[1] + "," + listecolonnes[2];
                break;
            case 4:
                requette += listecolonnes[0] + "," + listecolonnes[1] + "," + listecolonnes[2] + "," + listecolonnes[3];
                break;
            default:
                break;
        }


        requette += " FROM maille.mailles ";
        requette += state.territoire === "BDR" ?  " WHERE dep13=1 " : " WHERE amp=1 ";

        // console.log({requette})

        var result = await fetch(config.serveur + "bdd/maille/" + requette,
        {
            headers:{
                Authorization:state.jeton,
            }
        })
        var data = await result.json();

        var cerclemax = 600;
        var cerclemin = 50;
        //nombre de variable affichées
        var nbre = 0;
        if (typeof variable1 !== 'undefined') {
            nbre++;
        }
        if (typeof variable2 !== 'undefined') {
            nbre++;
        }
        if (typeof variable3 !== 'undefined') {
            nbre++;
        }
        //Une seule variable sélectionnée
        if (nbre === 1) {
            var i = 0;
            maillage = new VectorSource({
            });
            var listeplagecercleproportionnel = [];
            if (typeof cercleproportionnel !== 'undefined')
                listeplagecercleproportionnel = getplageValeurs(state);

            for (i in data) {
                let cercle = cerclemax;
                if (typeof data[i].var4 != "undefined" && data[i].var4 !== null) {
                    var pas = cerclemax / (listeplagecercleproportionnel.length);
                    if (typeof data[i].var4 != "undefined" && data[i].var4 !== null) {
                        cercle = 0;
                        var var4 = parseFloat(data[i].var4);
                        for (var j = 0; j < listeplagecercleproportionnel.length; j++) {
                            if (var4 < parseFloat(listeplagecercleproportionnel[j])) {
                                cercle = pas * j + cerclemin;
                                j = listeplagecercleproportionnel.length + 10;
                            }
                        }
                        if (cercle === 0) {
                            cercle = cerclemax;
                        }
                        //}
                    }
                }

                var quartiles1 = [];
                var quartiles2 = [];
                var quartiles3 = [];
                if (typeof data[i].var1 != "undefined") {
                    var variables = state.theme1;
                    if (state.territoire === "BDR") {
                        quartiles1 = [variables.quantile25_amp, variables.quantile50_amp, variables.quantile75_amp];
                    } else {
                        quartiles1 = [variables.quantile25_dep, variables.quantile50_dep, variables.quantile75_dep];
                    }
                }
                if (typeof data[i].var2 != "undefined") {
                    variables = state.theme2;
                    if (state.territoire === "BDR") {
                        quartiles2 = [variables.quantile25_amp, variables.quantile50_amp, variables.quantile75_amp];
                    } else {
                        quartiles2 = [variables.quantile25_dep, variables.quantile50_dep, variables.quantile75_dep];
                    }
                }
                if (typeof data[i].var3 != "undefined") {
                    variables = state.theme3;
                    if (state.territoire === "BDR") {
                        quartiles3 = [variables.quantile25_amp, variables.quantile50_amp, variables.quantile75_amp];
                    } else {
                        quartiles3 = [variables.quantile25_dep, variables.quantile50_dep, variables.quantile75_dep];
                    }
                }

                var f = new Feature({
                    geometry: new Circle([parseFloat(data[i].x), parseFloat(data[i].y)], cercle),
                    id: data[i].id,
                    nbre1: data[i].var1,
                    quartiles1: quartiles1,
                    nbre2: data[i].var2,
                    quartiles2: quartiles2,
                    nbre3: data[i].var3,
                    quartiles3: quartiles3,
                    nbre4: data[i].var4,
                    nom: "maille",
                    operation1: getOperation(variable1),
                    operation2: getOperation(variable2),
                    operation3: getOperation(variable3),
                    ...state.checkThemes

                });
                if (f !== "undefined")
                    maillage.addFeature(f);
            } // end forEach  

            maillage = new VectorLayer({
                source: maillage,
                crossOrigin: "Anonymous",
                style: getStyleRondMaille1Variable,
                nom: "mailles"
            });
            //map.addLayer(maillage);
        }

        else {
            listeplagecercleproportionnel = [];
            if (typeof cercleproportionnel !== 'undefined')
                listeplagecercleproportionnel = getplageValeurs(state);
            maillage = new VectorSource({});
            for (i in data) {
                var cercle = cerclemax;
                if (typeof data[i].var4 != "undefined" && data[i].var4 !== null) {
                    pas = cerclemax / (listeplagecercleproportionnel.length);
                    cercle = 0;
                    var4 = parseFloat(data[i].var4);
                    for (j = 0; j < listeplagecercleproportionnel.length; j++) {
                        if (parseFloat(var4) < listeplagecercleproportionnel[j]) {
                            cercle = pas * j + 100;
                            j = listeplagecercleproportionnel.length + 10;
                        }
                    }
                    if (cercle === 0) {
                        cercle = cerclemax
                    }
                }
                quartiles1 = [];
                quartiles2 = [];
                quartiles3 = [];
                if (typeof data[i].var1 != "undefined") {
                    if (state.territoire !== "BDR") {
                        quartiles1 = [variable1.quantile25_amp, variable1.quantile50_amp, variable1.quantile75_amp];
                    } else {
                        quartiles1 = [variable1.quantile25_dep, variable1.quantile50_dep, variable1.quantile75_dep];
                    }
                }
                if (typeof data[i].var2 != "undefined") {
                    if (state.territoire !== "BDR") {
                        quartiles2 = [variable2.quantile25_amp, variable2.quantile50_amp, variable2.quantile75_amp];
                    } else {
                        quartiles2 = [variable2.quantile25_dep, variable2.quantile50_dep, variable2.quantile75_dep];
                    }
                }
                if (typeof data[i].var3 != "undefined") {
                    if (state.territoire !== "BDR") {
                        quartiles3 = [variable3.quantile25_amp, variable3.quantile50_amp, variable3.quantile75_amp];
                    } else {
                        quartiles3 = [variable3.quantile25_dep, variable3.quantile50_dep, variable3.quantile75_dep];
                    }
                }


                f = new Feature({
                    geometry: new Circle([parseFloat(data[i].x), parseFloat(data[i].y)], cercle),
                    id: data[i].id,
                    nbre1: data[i].var1,
                    nbre2: data[i].var2,
                    nbre3: data[i].var3,
                    nbre4: data[i].var4,
                    nom: "maille",
                    operation1: getOperation(variable1),
                    operation2: getOperation(variable2),
                    operation3: getOperation(variable3),
                    quartiles1,
                    quartiles2,
                    quartiles3,
                    ...state.checkThemes

                })

                if (f !== "undefined") {
                    maillage.addFeature(f);
                }
            }
            maillage = new VectorLayer({
                source: maillage,
                crossOrigin: "Anonymous",
                style: getStyleRondMaille2Variables,
                nom: "mailles",
                type: "MAILLES"
            });
        };
    }

    return maillage;
}

function getOperation(variable, arrondir) {
    if (typeof variable === "undefined") return "";

    var operation = "";

    if (arrondir) {
        operation = variable.signe === "inf" ? "<=" : ">=";
        operation += (variable.valeurtest === "Saisie") ?
            arrondir(parseFloat(variable.valeursaisie)) :
            arrondir(parseFloat(variable.valeurtest));
    }
    else {
        operation = {}
        operation.signe = variable.signe;
        operation.valeur = (variable.valeurtest === "Saisie") ?
            parseFloat(variable.valeursaisie) :
            parseFloat(variable.valeurtest);
    }
    // console.log(operation)
    return operation;
}



function getplageValeurs(state) {
    return state.territoire !== "BDR" ? state.cercleproportionnel.plage_amp.split("|") : state.cercleproportionnel.plage_dep.split("|");
}

